import { render, staticRenderFns } from "./rightBox.vue?vue&type=template&id=2989a6dc&scoped=true"
import script from "./rightBox.vue?vue&type=script&lang=js"
export * from "./rightBox.vue?vue&type=script&lang=js"
import style0 from "./rightBox.vue?vue&type=style&index=0&id=2989a6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989a6dc",
  null
  
)

export default component.exports